module.exports = __webpack_public_path__ + "img/24hoursline.0d66a36e.svg";